import { UITypes } from "types"

import { CustomerEmail } from "components/table/columnComponents/CustomerEmail"
import { IntelligenceReportsKeyIndicatorCell } from "components/table/columnComponents/IntelligenceReportsKeyIndicatorCell"
import { IntelligenceReportsPriorityCell } from "components/table/columnComponents/IntelligenceReportsPriorityCell"

const intelligenceReportsTableHeaderCells: UITypes.TableHeaderCell[] = [
  {
    title: "Thermostat S/N",
    type: "sort-search",
    name: "sn",
    size: "middle",
  },
  {
    title: "Priority",
    type: "default",
    name: "priority",
    size: "small",
    cellComponent: IntelligenceReportsPriorityCell,
  },
  {
    title: "Key indicators",
    type: "default",
    name: "key_indicators",
    size: "large",
    cellComponent: IntelligenceReportsKeyIndicatorCell,
  },
  {
    title: "Customer Email",
    type: "sort-search",
    name: "customer_email",
    size: "middle",
    cellComponent: CustomerEmail,
  },
  {
    title: "Customer Name",
    type: "sort-search",
    name: "customer_name",
    size: "middle",
  },
]

export default intelligenceReportsTableHeaderCells
